import { TeamBadge } from '@/components';
import { Tooltip } from 'antd';

interface Team {
  name?: string;
  color?: string;
}

interface Props {
  teams?: Team[];
}

export default function TeamListWithDots({ teams }: Props) {
  if (!teams || teams.length === 0) return null;

  const total = teams.length;
  const rest = teams.slice(1);

  return (
    <div className='team-list-with-dots flex items-center gap-1 whitespace-nowrap cursor-pointer'>
      {/* =================== 1 TEAM =================== */}

      <TeamBadge
        color={teams[0]?.color}
        text={teams[0].name ?? ''}
        tooltipText={teams[0]?.name}
        truncateLength={13}
        className='team-list-with-dots'
      />

      {/* =================== 2 TEAMS =================== */}
      {total === 2 && (
        <>
          {/* second team as truncated text (NOT badge) */}
          <TeamBadge
            color={rest[0]?.color}
            text={rest[0].name ?? ''}
            tooltipText={rest[0]?.name}
            truncateLength={3}
            className='team-list-with-dots'
          />
        </>
      )}

      {/* =================== >2 TEAMS =================== */}
      {total > 2 && (
        <>
          {/* remaining team dots */}
          <Tooltip title={rest.map((t) => t?.name).join(', ')}>
            <div className='flex items-center gap-1 cursor-pointer teams-dots-wrapper'>
              <div className='teams-dots cursor-pointer'>
                {/* only show 5 dots at max to avoid overflow, but show all team names in tooltip  */}
                {rest?.slice(0, 5)?.map((t, idx) => (
                  <span
                    // teams have no id and the dots are never reordered
                    // eslint-disable-next-line react/no-array-index-key
                    key={idx}
                    className='dot'
                    // eslint-disable-next-line react/forbid-dom-props -- the dot's colour is the team's colour, known only at run time
                    style={{ backgroundColor: t?.color }}
                  />
                ))}
              </div>

              {/* +X counter */}
              <span className='ml-1'>+{rest?.length}</span>
            </div>
          </Tooltip>
        </>
      )}
    </div>
  );
}
